export interface IModal {
  visible: boolean;
}

export interface IHaveActiveDailyRents {
  value: boolean;
}

export interface ILead {
  exists: boolean;
  status: ELeadStatus;
}

export enum ELeadStatus {
  Init = 'init',
  Success = 'success',
  Failed = 'failed',
}

export type TSaveLeadParams = {
  name: string;
  phone: string;
  email: string;
};

export interface INotificationsState {
  list: INotification[];
}

export interface INotification {
  id?: string;
  type: 'success' | 'error' | 'info' | 'progress' | 'spinner';
  text: string;
  placement?: 'bottom-center' | 'bottom-right';
}
